import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Chip from 'Chip';
import FList from '../focuslist';
import BannerPic from './bannerPic';

/**
 * 定义 RecommendTit 组件
 */
class RecommendTit extends React.PureComponent {
    render() {
        const { content } = this.props;

        return (
            <div className={styles.titA}>
                <div className={styles.spTit}>
                    <a href={content.url} target="_blank" rel="noreferrer">
                        {content.title}
                    </a>
                </div>
            </div>
        );
    }
}

/**
 * 定义组件属性类型
 * */
RecommendTit.propTypes = { content: PropTypes.object };

/**
 * 定义组件
 */
class FocusBanner extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        return (
            <div className={styles.w1000}>
                {/* <Chip id="255125" type="recommend" title="头条推荐" groupName="头条推荐" content={content.list}>
                    <FList />
                </Chip> */}
                <div className={styles.boxl}>
                    <Chip
                        id="360611"
                        type="dynamic"
                        title="银行观察最新"
                        groupName="银行观察最新"
                        content={content?.bankNews}>
                        <FList />
                    </Chip>
                    <Chip
                        id="360614"
                        type="dynamic"
                        title="基金观察最新"
                        groupName="基金观察最新"
                        content={content?.fundNews}>
                        <FList />
                    </Chip>
                    <Chip
                        id="360615"
                        type="dynamic"
                        title="保险观察最新"
                        groupName="保险观察最新"
                        content={content?.InsuranceNews}>
                        <FList />
                    </Chip>
                </div>

                <div className={styles.boxr}>
                    {/* <Chip id="230098" type="struct" title="视频解盘标题" groupName="正文" content={content.videoTitle}>
                        <RecommendTit />
                    </Chip>
                    <Chip id="225061" type="recommend" title="视频解盘视频" groupName="正文" content={content.video}>
                        <VideoBox />
                    </Chip> */}
                    {/* <Chip id="160168" type="static" title="头条视频" groupName="头条推荐" content={content.videoInfo}>
                        <Recommend />
                    </Chip> */}
                    <Chip
                        id="285836"
                        type="recommend"
                        title="视频焦点图"
                        groupName="正文"
                        content={content.videoSlide}>
                        <BannerPic />
                    </Chip>
                </div>
            </div>
        );
        // return footer;
    }
}

export default errorBoundary(FocusBanner);
